import { inject, Injectable } from "@angular/core";

import { Observable, tap } from "rxjs";

import { RequestState, SettingsResponse } from "@shared/models";
import { GlobalService, SettingsApiService } from "@shared/services";

@Injectable({
  providedIn: "root",
})
export class SettingsPageService {
  globalService = inject(GlobalService);
  settingsApiService = inject(SettingsApiService);

  settings: SettingsResponse = {} as SettingsResponse;

  getSettings(): Observable<RequestState<SettingsResponse>> {
    return this.settingsApiService.getSettings().pipe(
      tap((response) => {
        if (response.response) {
          this.settings = response.response;
        }
      })
    );
  }

  saveSettings(newValue: string, valueType: "vmax" | "proj"): Observable<RequestState<SettingsResponse>> {
    const vmaxValue = valueType === "vmax" ? newValue : this.settings.vMaxDefault;
    const projValue = valueType === "proj" ? newValue : this.settings.projDefault;
    return this.settingsApiService.updateSettings(this.settings, vmaxValue, projValue);
  }
}
